/* __next_internal_client_entry_do_not_use__ useSDUIFilterablePaginatedSectionFilters auto */ import { getBrandValuesFilterKey } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Fetching/getBrandValuesFilterKey";
import { useSDUIFilterablePaginatedSectionState } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Filters/useSDUIFilterablePaginatedSectionState";
import { useMemo } from "react";
import { useRouteMatch } from "react-router-dom";
// This is non RSC compatible. Use useServerCompatibleSDUIFilterablePaginatedSectionState instead.
export var useSDUIFilterablePaginatedSectionFilters = function() {
    var filterKeys = useSDUIFilterablePaginatedSectionState().filterKeys;
    var match = useRouteMatch();
    return useMemo(function() {
        var brandValueFilterKey = getBrandValuesFilterKey(match.params.brandValue);
        if (brandValueFilterKey && !filterKeys.includes(brandValueFilterKey)) {
            filterKeys.push(brandValueFilterKey);
        }
        return filterKeys;
    }, [
        filterKeys,
        match.params.brandValue
    ]);
};
